const WEEBLY = 'https://alinabokovikova.weebly.com/uploads/5/9/0/8/59081429/';

function sketchSvg(title, hue, variant = 0) {
  const figures = [
    `<ellipse cx='300' cy='180' rx='42' ry='52'/><path d='M 258 230 L 240 380 L 200 600 L 250 720 L 350 720 L 400 600 L 360 380 L 342 230 Z'/>`,
    `<ellipse cx='300' cy='170' rx='38' ry='48'/><path d='M 262 220 L 230 360 L 180 700 L 240 720 L 280 540 L 300 540 L 320 540 L 360 720 L 420 700 L 370 360 L 338 220 Z'/>`,
    `<ellipse cx='300' cy='190' rx='44' ry='54'/><path d='M 256 240 L 220 400 L 160 580 L 200 620 L 250 480 L 280 480 L 280 720 L 320 720 L 320 480 L 350 480 L 400 620 L 440 580 L 380 400 L 344 240 Z'/>`,
  ];
  const inkColor = '#2a1f12';
  const paper = '#f0e6d2';
  const seed = (title.length + variant) % 10;
  const svg = `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 600 800' preserveAspectRatio='xMidYMid slice'>
    <defs>
      <filter id='paper' x='0' y='0'>
        <feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2' seed='${seed}'/>
        <feColorMatrix values='0 0 0 0 0.95  0 0 0 0 0.90  0 0 0 0 0.82  0 0 0 0.12 0'/>
        <feComposite in2='SourceGraphic' operator='in'/>
      </filter>
    </defs>
    <rect width='600' height='800' fill='${paper}'/>
    <rect width='600' height='800' fill='${paper}' filter='url(#paper)'/>
    <rect x='28' y='28' width='544' height='744' fill='none' stroke='${inkColor}' stroke-width='0.7' opacity='0.4'/>
    <ellipse cx='150' cy='${360 + variant * 40}' rx='110' ry='80' fill='hsl(${hue},55%,52%)' opacity='0.28'/>
    <ellipse cx='${440 - variant * 30}' cy='${520 + variant * 20}' rx='90' ry='65' fill='hsl(${(hue + 45) % 360},48%,58%)' opacity='0.22'/>
    <ellipse cx='${280 + variant * 40}' cy='600' rx='70' ry='50' fill='hsl(${(hue + 200) % 360},30%,40%)' opacity='0.18'/>
    <g fill='${inkColor}' opacity='0.82'>${figures[variant % figures.length]}</g>
    <g stroke='${inkColor}' stroke-width='1' fill='none' opacity='0.6'>
      <path d='M 240 280 Q 300 260 360 280'/>
      <path d='M 220 460 Q 300 440 380 460'/>
      <path d='M 260 360 L 340 360'/>
    </g>
    <g transform='translate(440,80)'>
      <rect width='50' height='48' fill='hsl(${hue},60%,42%)' stroke='${inkColor}' stroke-width='0.5'/>
      <rect y='52' width='50' height='48' fill='hsl(${(hue + 30) % 360},45%,55%)' stroke='${inkColor}' stroke-width='0.5'/>
      <rect y='104' width='50' height='48' fill='hsl(${(hue + 200) % 360},25%,28%)' stroke='${inkColor}' stroke-width='0.5'/>
      <rect y='156' width='50' height='48' fill='hsl(${(hue - 20 + 360) % 360},35%,72%)' stroke='${inkColor}' stroke-width='0.5'/>
    </g>
    <g stroke='${inkColor}' stroke-width='0.6' fill='none' opacity='0.5'>
      <line x1='300' y1='240' x2='430' y2='200'/>
      <line x1='280' y1='400' x2='420' y2='280'/>
    </g>
    <text x='430' y='195' font-family='Georgia, serif' font-style='italic' font-size='12' fill='${inkColor}' opacity='0.75'>silk taffeta</text>
    <text x='420' y='275' font-family='Georgia, serif' font-style='italic' font-size='12' fill='${inkColor}' opacity='0.75'>antique brocade</text>
    <line x1='60' y1='700' x2='540' y2='700' stroke='${inkColor}' stroke-width='0.5' opacity='0.4'/>
    <text x='60' y='735' font-family='Georgia, serif' font-style='italic' font-size='26' fill='${inkColor}'>${title.slice(0, 40)}</text>
    <text x='60' y='755' font-family='Helvetica, sans-serif' font-size='10' fill='${inkColor}' letter-spacing='4' opacity='0.6'>COSTUME PLATE · A. BOKOVIKOVA</text>
  </svg>`;
  return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
}

function btsSvg(title, hue) {
  const seed = title.length % 9;
  const svg = `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 600 800' preserveAspectRatio='xMidYMid slice'>
    <defs>
      <radialGradient id='g' cx='50%' cy='40%'>
        <stop offset='0%' stop-color='hsl(${hue},20%,18%)'/>
        <stop offset='100%' stop-color='#0a0a0a'/>
      </radialGradient>
      <filter id='grain'>
        <feTurbulence type='fractalNoise' baseFrequency='1.2' numOctaves='2' seed='${seed}'/>
        <feColorMatrix values='0 0 0 0 0.9  0 0 0 0 0.85  0 0 0 0 0.7  0 0 0 0.08 0'/>
      </filter>
    </defs>
    <rect width='600' height='800' fill='url(#g)'/>
    <line x1='80' y1='180' x2='520' y2='180' stroke='#888' stroke-width='2' opacity='0.5'/>
    <line x1='90' y1='160' x2='90' y2='180' stroke='#888' stroke-width='1.5' opacity='0.5'/>
    <line x1='510' y1='160' x2='510' y2='180' stroke='#888' stroke-width='1.5' opacity='0.5'/>
    <g opacity='0.55'>
      <path d='M 130 180 L 110 480 L 160 500 L 170 200 Z' fill='hsl(${hue},35%,30%)'/>
      <path d='M 200 180 L 175 520 L 240 540 L 250 200 Z' fill='hsl(${(hue + 30) % 360},40%,38%)'/>
      <path d='M 290 180 L 270 460 L 330 480 L 340 200 Z' fill='hsl(${(hue + 180) % 360},25%,28%)'/>
      <path d='M 380 180 L 360 510 L 430 530 L 440 200 Z' fill='hsl(${(hue - 30 + 360) % 360},30%,42%)'/>
      <path d='M 470 180 L 450 470 L 500 490 L 510 200 Z' fill='hsl(${(hue + 90) % 360},20%,32%)'/>
    </g>
    <ellipse cx='300' cy='600' rx='200' ry='40' fill='hsl(${hue},40%,50%)' opacity='0.12'/>
    <rect width='600' height='800' filter='url(#grain)' opacity='0.4'/>
    <text x='60' y='720' font-family='Georgia, serif' font-style='italic' font-size='24' fill='#e8dfc8' opacity='0.92'>${title.slice(0, 38)}</text>
    <text x='60' y='745' font-family='Helvetica, sans-serif' font-size='10' fill='#c8b890' letter-spacing='4' opacity='0.7'>BEHIND THE SCENES · FITTING ROOM</text>
  </svg>`;
  return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
}

function moodSvg(title, hue) {
  const blocks = [];
  for (let i = 0; i < 20; i++) {
    const x = (i * 37) % 600;
    const y = (i * 71) % 800;
    blocks.push(`<rect x='${x}' y='${y}' width='${40 + (i % 5) * 20}' height='${30 + (i % 4) * 15}' fill='hsl(${(hue + i * 8) % 360},${30 + (i % 20)}%,${20 + (i % 30)}%)' opacity='0.5'/>`);
  }
  const svg = `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 600 800'>
    <rect width='600' height='800' fill='hsl(${hue},20%,12%)'/>
    ${blocks.join('')}
    <rect width='600' height='800' fill='url(#grad)' opacity='0.6'/>
    <defs><linearGradient id='grad' x2='0' y2='1'><stop offset='0%' stop-color='transparent'/><stop offset='100%' stop-color='#000'/></linearGradient></defs>
    <text x='60' y='740' font-family='Georgia,serif' font-style='italic' font-size='22' fill='#f0e6d2'>${title.slice(0, 38)}</text>
    <text x='60' y='760' font-family='Helvetica,sans-serif' font-size='10' fill='#c8b890' letter-spacing='4' opacity='0.7'>FABRIC STUDY · DETAIL</text>
  </svg>`;
  return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
}

const PETER_PAN_GALLERY = [
  { kind: 'Video', ytUrl: 'https://youtu.be/ZnCHEaYKtVM', thumb: '/peter-pan-panto-presidio.jpg', caption: 'Peter Pan · Production Video' },
  { kind: 'Production', src: '/Peter-Pan-Header_Photo-Credit-Terry-Lorant.jpg', caption: 'Peter Pan · Presidio Theatre · Photo: Terry Lorant' },
  { kind: 'Production', src: '/Peter-Pan-Banner-2048x997-1-1024x499.jpg',       caption: 'Full company · Panto in the Presidio' },
  { kind: 'Production', src: '/peter-pan3.png',                                  caption: 'Costumes in action' },
  { kind: 'Production', src: '/peter-pan4.png',                                  caption: 'Character detail' },
  { kind: 'Production', src: '/peter-pan5.png',                                  caption: 'Stage moment' },
  { kind: 'Production', src: '/peter-pan6.png',                                  caption: 'Costume detail' },
  { kind: 'Production', src: '/peter-pan7.png',                                  caption: 'Behind the scenes' },
];

const REAL = [
  { title: 'Peter Pan', type: 'Panto', year: 2025, venue: 'Presidio Theatre', hue: 195, mainImg: '/Peter-Pan-Header_Photo-Credit-Terry-Lorant.jpg', gallery: PETER_PAN_GALLERY },
  { title: 'Threepenny Opera',             type: 'Opera',      year: 2018, venue: 'Cutting Ball Theatre',    hue: 28,  main: '2390598.jpg' },
  { title: 'Agrippina',                    type: 'Opera',      year: 2017, venue: 'Opera Parallèle',         hue: 348, main: '2949575.jpg' },
  { title: 'The Magic Flute',              type: 'Opera',      year: 2016, venue: 'San Francisco Opera',     hue: 220, main: '6674228.jpg' },
  { title: 'School For Lies',              type: 'Theater',    year: 2015, venue: 'The Old Globe',           hue: 15,  main: '288962.jpg'  },
  { title: "A Doll's House",               type: 'Theater',    year: 2019, venue: 'TheatreWorks',            hue: 200, main: '8104100.jpg' },
  { title: 'Camino Real',                  type: 'Theater',    year: 2014, venue: 'La Jolla Playhouse',      hue: 5,   main: '2684734.jpg' },
  { title: 'Fallen Angels',               type: 'Theater',    year: 2018, venue: 'North Coast Rep',         hue: 320, main: '6577716.jpg' },
  { title: 'Scapan',                       type: 'Theater',    year: 2013, venue: 'The Old Globe',           hue: 38,  main: '984519.jpg'  },
  { title: 'Gunmetal Blues',               type: 'Theater',    year: 2017, venue: 'Cygnet Theatre',          hue: 215, main: '2822809.jpg' },
  { title: 'Unnecessary Farce',            type: 'Theater',    year: 2016, venue: 'North Coast Rep',         hue: 50,  main: '5674490.jpg' },
  { title: 'Becoming Cuba',               type: 'Theater',    year: 2015, venue: 'San Diego Rep',           hue: 12,  main: '2349818.jpg' },
  { title: 'Underpants',                   type: 'Theater',    year: 2014, venue: 'New Village Arts',        hue: 0,   main: '1654614.jpg' },
  { title: 'Broken Glass',                 type: 'Theater',    year: 2013, venue: 'North Coast Rep',         hue: 240, main: '7199079.jpg' },
  { title: 'Great American Trailer Park',  type: 'Theater',    year: 2012, venue: 'Cygnet Theatre',          hue: 180, main: '101752.jpg'  },
  { title: 'Chapter Two',                  type: 'Theater',    year: 2014, venue: 'North Coast Rep',         hue: 25,  main: '5701130.jpg' },
  { title: 'Les Noces',                    type: 'Dance',      year: 2016, venue: 'Allyson Green Dance',     hue: 350, main: '340117.jpg'  },
  { title: 'Pause. The World Creation.',   type: 'Dance',      year: 2015, venue: 'Alicia Peterson Baskel',  hue: 270, main: '3107362.jpg' },
  { title: 'Body Parts',                   type: 'Dance',      year: 2014, venue: 'Patricia Rincon',         hue: 0,   main: '6322332.jpg' },
  { title: 'The Bird Lady',                type: 'Dance Film', year: 2015, venue: 'Rebecca Salzer',          hue: 42,  main: '1736864.jpg' },
  { title: 'Stereoblind',                  type: 'Dance Film', year: 2014, venue: 'Rebecca Salzer',          hue: 195, main: '3864387.jpg' },
];

const INVENTED = [
  { title: 'Madama Butterfly',   type: 'Opera',   year: 2020, venue: 'Opera San Jose',         hue: 350 },
  { title: 'The Cherry Orchard', type: 'Theater', year: 2021, venue: 'California Shakespeare', hue: 100 },
  { title: 'Twelfth Night',      type: 'Theater', year: 2019, venue: 'California Shakespeare', hue: 200 },
  { title: 'Carmen',             type: 'Opera',   year: 2022, venue: 'Opera Parallèle',        hue: 0   },
  { title: 'Rite of Spring',     type: 'Dance',   year: 2023, venue: 'ODC/Dance',              hue: 30  },
];

export const PROJECTS = [...REAL, ...INVENTED].map((p, i) => {
  const id = p.title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '') + '-' + i;
  const mainImg = p.mainImg ?? (p.main ? WEEBLY + p.main : moodSvg(p.title, p.hue));
  if (p.gallery) return { id, ...p, mainImg };
  const gallery = [];
  gallery.push({ kind: 'Production', src: mainImg, caption: `${p.title} · ${p.venue}` });
  gallery.push({ kind: 'Production', src: moodSvg(p.title, p.hue), caption: 'Stage moment' });
  const sketchCount = 2 + (i % 2);
  for (let s = 0; s < sketchCount; s++) {
    gallery.push({ kind: 'Sketch', src: sketchSvg(p.title, p.hue, s), caption: `Costume plate ${s + 1}` });
  }
  gallery.push({ kind: 'Behind the Scenes', src: btsSvg(p.title, p.hue), caption: 'Fitting & build' });
  if (i % 3 === 0) {
    gallery.push({ kind: 'Behind the Scenes', src: btsSvg(p.title + ' II', p.hue), caption: 'Wardrobe call' });
  }
  return { id, ...p, mainImg, gallery };
});